(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4783],{

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ BackButtonBar; },
/* harmony export */   "x": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91289);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40774);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71345);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BackButtonBar = function BackButtonBar(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    "data-navigate-row": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackButton, {
      onClick: onClick,
      className: buttonClassName
    })
  });
};
var BackButton = function BackButton(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    "data-navigate-item": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().back), className),
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: t("back")
    })]
  });
};

/***/ }),

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 71590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TermsOfUse": function() { return /* binding */ TermsOfUse; }
/* harmony export */ });
/* harmony import */ var app_components_back_button_back_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56227);
/* harmony import */ var app_hooks_navigation_hook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26793);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var _terms_of_use_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49734);
/* harmony import */ var _terms_of_use_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_terms_of_use_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);







var TermsOfUse = function TermsOfUse() {
  var _response$data, _response$data2;

  var goBack = (0,app_hooks_navigation_hook__WEBPACK_IMPORTED_MODULE_1__/* .useNavigateBack */ .ub)();
  var response = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)("terms-of-use", function () {
    return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/media/docs/Term-of-use.html");
  });
  var body = (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.data ? /<body.*?>([\s\S]*)<\/body>/.exec((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data) : null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(app_components_back_button_back_button_component__WEBPACK_IMPORTED_MODULE_0__/* .BackButtonBar */ .K, {
      onClick: goBack
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_terms_of_use_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iframe_wrapper),
      children: body && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_terms_of_use_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper),
        dangerouslySetInnerHTML: {
          __html: body[1]
        }
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (TermsOfUse);

/***/ }),

/***/ 58123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-use",
      function () {
        return __webpack_require__(71590);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back":"back-button_back__KRknK","forgot_button":"back-button_forgot_button__Jmz7Z","wrapper":"back-button_wrapper__cmCKR","absolute":"back-button_absolute__HllSl"};

/***/ }),

/***/ 49734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","header":"terms-of-use_header__apz7G","wrapper":"terms-of-use_wrapper__Lemm9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(58123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);